import { ConfigProvider, Input } from 'antd';
import colorTheme from 'constants/color';
import useDebounce from 'hooks/useDebounce';
import styled from 'styled-components';

interface InputSearchProps {
  value?: string,
  onChange?: (val: string) => void,
}

const InputSearch = ({value, onChange}: InputSearchProps) => {
  const { text, setText } = useDebounce({ value: value, onDebounce: onChange });

  return (
    <Container>
      <InputStyled
        value={text}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setText(e.target.value)}
        placeholder={'Enter role'}
      />
      <SuffixContainer>
        <SearchIcon/>
      </SuffixContainer>
    </Container>
  );
};

export default InputSearch;

const SearchIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5259_15416)">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z" fill="#FFFFFF" />
      <path fillRule="evenodd" clipRule="evenodd" d="M17.4875 17.9555C17.78 17.6622 18.2549 17.6616 18.5482 17.9541L22.0722 21.469C22.3655 21.7615 22.3661 22.2363 22.0736 22.5296C21.7811 22.8229 21.3062 22.8235 21.0129 22.531L17.4889 19.0161C17.1956 18.7236 17.195 18.2487 17.4875 17.9555Z" fill="#FFFFFF" />
    </g>
    <defs>
      <clipPath id="clip0_5259_15416">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Container = styled.div`
  border-radius: 99px;
  border: 2px solid ${colorTheme['v2_secondary_3']};
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  padding-left: 16px;
  flex: 1;
`;

const InputStyled = styled(Input)`
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
`;

const SuffixContainer = styled.div`
  width: 56px;
  background-color: ${colorTheme['v2_secondary_3']};
  height: 100%;
  border-radius: 0px 99px 99px 0px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
`;